import React from "react"
import { Button, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router";

function RefundsIncomingCard(){
    const navigate = useNavigate();
    return<React.Fragment>
    <Card sx={{width:'300px', position:'relative', overflow: 'visible'}}>
    <Button 
        variant='contained' 
        color="primary" 
        sx={{
            position: 'absolute', 
            bottom: '-15px', 
            right: '-15px', 
            backgroundColor:'#62BCBD',
            borderRadius: '20px',
        }} onClick={()=>navigate('/RefundsIncoming')}>View</Button>
    <CardHeader title="Refunds Incoming" sx={{backgroundColor:'#62BCBD', color:'white', height:'40px'}}/>
    <CardContent>
        <Stack direction="row" spacing={2}>
            <Typography variant="body1">Status of refunds in progress</Typography>
        </Stack>
    </CardContent>
    </Card>      
    </React.Fragment>
}
export {RefundsIncomingCard}